// shared-components/ui/LoadingSpinner.jsx
import PropTypes from "prop-types";
import { cn } from "@shared/lib/utils";
import {
  getAllValidSizes,
  normalizeSize,
} from "@shared/constants/componentSizes";

function LoadingSpinner({
  size = "md",
  color = "primary",
  className = "",
  ...props
}) {
  // Size classes using unified system
  const sizeClasses = {
    xs: "h-4 w-4 border-2",
    sm: "h-5 w-5 border-2",
    md: "h-8 w-8 border-3",
    lg: "h-12 w-12 border-4",
    xl: "h-16 w-16 border-4",
  };

  // Normalize size for backward compatibility
  const normalizedSize = normalizeSize(size);

  // Color classes
  const colorClasses = {
    primary: "border-primary-500 border-t-transparent",
    secondary: "border-secondary-500 border-t-transparent",
    white: "border-white border-t-transparent",
    gray: "border-gray-300 border-t-transparent dark:border-gray-600",
  };

  return (
    <div
      className={cn("flex items-center justify-center", className)}
      {...props}
    >
      <div
        className={cn(
          "rounded-full animate-spin",
          sizeClasses[normalizedSize] || sizeClasses.md,
          colorClasses[color] || colorClasses.primary,
        )}
        role="status"
        aria-label="Loading"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(getAllValidSizes()),
  color: PropTypes.oneOf(["primary", "secondary", "white", "gray"]),
  className: PropTypes.string,
};

export default LoadingSpinner;
export { LoadingSpinner };
